import { render, staticRenderFns } from "./Velorio.vue?vue&type=template&id=3bc4e06f&scoped=true"
import script from "./Velorio.vue?vue&type=script&lang=js"
export * from "./Velorio.vue?vue&type=script&lang=js"
import style0 from "./Velorio.vue?vue&type=style&index=0&id=3bc4e06f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bc4e06f",
  null
  
)

export default component.exports